export function isWithin24Hours(session) {
  const { date, time } = session;
  const sessionDateTime = new Date(`${date}T${time}:00`);
  const currentDateTime = new Date();
  const timeDifference = sessionDateTime - currentDateTime;
  const differenceInHours = timeDifference / (1000 * 60 * 60);
  return differenceInHours <= 24 && differenceInHours > 0;
}
